import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { environment } from 'src/assets/env/environment';
import { HelpEntry } from '../../models/knowledge.model';

@Injectable({ providedIn: 'root' })
export class KnowledgeService {
  private readonly baseUrl = `${environment.API_BASE_URL}/api/v1/knowledge`;

  /** DOCU-914: shared by the topic list and the titles of related topics. */
  private allEntries$?: Observable<HelpEntry[]>;

  constructor(private http: HttpClient) {}

  getEntry(id: string): Observable<HelpEntry | null> {
    return this.http.get<HelpEntry>(`${this.baseUrl}/${id}`).pipe(
      catchError(() => of(null))
    );
  }

  getEntries(area?: string): Observable<HelpEntry[]> {
    let params = new HttpParams();
    if (area) {
      params = params.set('area', area);
    }
    return this.http.get<HelpEntry[]>(this.baseUrl, { params }).pipe(
      catchError(() => of([]))
    );
  }

  /**
   * All entries, fetched once per session. The help content only changes with a
   * new API image, so re-fetching it while the panel is used buys nothing.
   */
  getAllEntriesCached(): Observable<HelpEntry[]> {
    if (!this.allEntries$) {
      this.allEntries$ = this.http.get<HelpEntry[]>(this.baseUrl).pipe(
        catchError(() => of([])),
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }
    return this.allEntries$;
  }

  getEntryByContextKey(contextKey: string): Observable<HelpEntry | null> {
    return this.http.get<HelpEntry>(`${this.baseUrl}/context/${contextKey}`).pipe(
      catchError(() => of(null))
    );
  }
}
